"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = __importDefault(require("swiper"));
const modules_1 = require("swiper/modules");
const initFirstScreen = ($firstScreen) => {
    const $swiper = $firstScreen.querySelector('.swiper');
    const $prevButtons = $firstScreen.querySelectorAll('.slider-controls__button-prev');
    const $nextButtons = $firstScreen.querySelectorAll('.slider-controls__button-next');
    const $pagination = $firstScreen.querySelector('.slider-pagination');
    if (!$swiper || !$prevButtons.length || !$nextButtons.length || !$pagination) {
        console.warn('Недостаточно элементов для инициализации слайдера!');
        return;
    }
    new swiper_1.default($swiper, {
        modules: [modules_1.Navigation, modules_1.Pagination, modules_1.Autoplay],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 4,
        speed: 1000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: $pagination,
            clickable: true,
        },
        navigation: {
            prevEl: '.slider-controls__button-prev',
            nextEl: '.slider-controls__button-next',
        },
    });
};
exports.default = initFirstScreen;
